import React from 'react';

class IncrementalText extends React.PureComponent {
  letterIndex = 0;
  incrementalTextInterval;

  constructor(props) {
    super(props);
    this.state = {
      text: ''
    };
  }

  startIncrementalText = () => {
    this.incrementalTextInterval = setInterval(() => {
      const { text } = this.props;
      if (this.letterIndex < text.length) {
        this.setState((prevState) => ({
          text: prevState.text + text[this.letterIndex]
        }));
        this.letterIndex += 1;
      } else {
        clearInterval(this.incrementalTextInterval);
        this.props.onComplete && this.props.onComplete();
      }
    }, 55);
  };

  componentDidMount() {
    if (this.props.start) {
      this.startIncrementalText();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      this.setState({ text: '' });
      this.letterIndex = 0;
      clearInterval(this.incrementalTextInterval);
      this.startIncrementalText();
    }

    if (!prevProps.start && this.props.start) {
      this.startIncrementalText();
    }

    if (!prevProps.complete && this.props.complete) {
      this.stopIncrementalText();
    }
  }

  componentWillUnmount() {
    clearInterval(this.incrementalTextInterval);
  }

  isComplete = () => {
    return this.letterIndex === this.props.text.length;
  };

  onClick = () => {
    this.props.onClick && this.props.onClick();
    this.stopIncrementalText();
  };

  stopIncrementalText = () => {
    clearInterval(this.incrementalTextInterval);
    this.setState({ text: this.props.text });
    this.letterIndex = this.props.text.length;
  };

  render() {
    const { text } = this.state;
    return (
      <div style={{ position: 'relative' }} onClick={this.onClick}>
        <div style={{ opacity: 0 }}>{this.props.text}</div>
        <div style={{ position: 'absolute', top: 0 }}>{text}</div>
      </div>
    );
  }
}

export default IncrementalText;

IncrementalText.defaultProps = {
  start: true
};
